import React from 'react';
import './SelectLanguage.scss';
import SingleLanguage from './SingleLanguage';
import { dataLocalStorage } from './dataLocalStorage';

import england from '../../../Assets/flags/england.webp';
import albania from '../../../Assets/flags/albania.webp';
import german from '../../../Assets/flags/german.webp';
import greece from '../../../Assets/flags/greece.webp';
import italy from '../../../Assets/flags/italy2.webp';
import japan from '../../../Assets/flags/japan.webp';
import russia from '../../../Assets/flags/russia.webp';
import saudi from '../../../Assets/flags/saudi.webp';
import spain from '../../../Assets/flags/spain.webp';
import turkey from '../../../Assets/flags/turkey.webp';
import france from '../../../Assets/flags/france.webp';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import { useDispatch , useSelector} from 'react-redux';
import {chooseLanguage } from '../../../store/actions/languageAction';

function SelectLanguage(){

    const dispatch = useDispatch();
    const language = useSelector((state) => state.language.language);

    const languages = [
        { value: 'en-GB', lang: 'English', flag: england },
        { value: 'sq-AL', lang: 'Albanian', flag: albania },
        { value: 'de-DE', lang: 'German', flag: german },
        { value: 'de-FR', lang: 'French', flag: france },
        { value: 'turkish', lang: 'Turkish', flag: turkey },
        { value: 'spanish', lang: 'Spanish', flag: spain },
        { value: 'italian', lang: 'Italian', flag: italy },
        { value: 'greek', lang: 'Greek', flag: greece },
        { value: 'arabic', lang: 'Arabic', flag: saudi },
        { value: 'russian', lang: 'Russian', flag: russia },
        { value: 'japanese', lang: 'Japanese', flag: japan },
      ];
      const handleLanguageChange = (language, locale) => {
        dispatch(chooseLanguage(locale));
        dataLocalStorage.setLanguage(language);
        dataLocalStorage.setLocale(locale);
      };
      let flag = null;
      switch (dataLocalStorage.getLocale()) {
        case 'en-GB':
          flag = england;
          break;
        case 'sq-AL':
          flag = albania;
          break;
        case 'de-DE':
          flag = german;
          case 'de-FR':
            flag = france;
            break;
            case 'turkish':
            flag = turkey;
            break;
            case 'spanish':
            flag = spain;
            break;
            case 'italian':
            flag = italy;
            break;
            case 'greek':
            flag = greece;
            break;
            case 'arabic':
            flag =saudi;
            break;
            case 'russian':
            flag = russia;
            break;
            case 'japanese':
            flag = japan;
            break;
          break;
        default:
          flag = england;
      }
      return (
        <div className='select-language'>
          <img src={flag} alt='selected flag' />
          {dataLocalStorage.getLanguage() || 'English'}
          <ExpandLessIcon className='arrow' styles='up' />
    
          <div className='dropdown'>
            {languages
              .sort(function (a, b) {
                let lang1 = a.lang.toUpperCase();
                let lang2 = b.lang.toUpperCase();
                if (lang1 < lang2) {
                  return -1;
                }
                if (lang1 > lang2) {
                  return 1;
                }
                // names must be equal
                return 0;
              })
              .map((thisLang, i) => {
                return (
                  <SingleLanguage
                    value={thisLang.value}
                    key={i}
                    handleLanguageChange={() =>
                      handleLanguageChange(thisLang.lang, thisLang.value)
                    }
                    styles={thisLang.value === language && 'selected'}
                    language={thisLang.lang}
                    flag={thisLang.flag}
                  ></SingleLanguage>
                );
              })}
          </div>
        </div>
      );
}
export default SelectLanguage;